import { Link } from "react-router-dom";

interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  desc?: string;
  align?: "left" | "center";
  actionHref?: string;
  actionLabel?: string;
}

export default function SectionHeading({
  eyebrow,
  title,
  desc,
  align = "left",
  actionHref,
  actionLabel,
}: SectionHeadingProps) {
  const isCenter = align === "center";

  return (
    <div
      className={`flex flex-col gap-4 md:flex-row md:items-end md:justify-between ${
        isCenter ? "md:flex-col md:items-center" : ""
      }`}
    >
      <div className={isCenter ? "text-center" : ""}>
        {eyebrow && (
          <p className="flex items-center gap-2 text-xs font-label font-medium uppercase tracking-[0.25em] text-primary-600">
            {!isCenter && <span className="h-px w-6 bg-primary-500" aria-hidden="true"></span>}
            {isCenter && <span className="mx-auto h-px w-6 bg-primary-500" aria-hidden="true"></span>}
            {eyebrow}
          </p>
        )}
        <h2 className="mt-3 font-heading text-2xl font-bold tracking-tight text-foreground-950 md:text-3xl">
          {title}
        </h2>
        {desc && (
          <p className={`mt-3 max-w-2xl text-sm leading-relaxed text-foreground-600 ${isCenter ? "mx-auto" : ""}`}>
            {desc}
          </p>
        )}
      </div>

      {actionHref && actionLabel && (
        <Link
          to={actionHref}
          className="inline-flex items-center gap-1.5 self-start rounded-md border border-background-300 px-4 py-2 text-sm font-label text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-700 whitespace-nowrap cursor-pointer md:self-auto"
        >
          {actionLabel}
          <i className="ri-arrow-right-line" aria-hidden="true"></i>
        </Link>
      )}
    </div>
  );
}